import { Item, Toolbar } from 'devextreme-react/toolbar';
import React from 'react';
import '../../components/datagridNoResponsive/DatagridNoResponsive.scss';
import { useTranslation } from '../../contexts/translation';
import { FailedLoad } from '../failedLoad/FailedLoad';
import { Loader } from '../loader/Loader';

interface Props {
  children: any;
  error?: any;
  loading?: any;
  noLoadingModal?: boolean;
  heading?: any;
  noTopPadding?: boolean;
}

export const DatagridNoResponsiveContainer = ({
  children,
  error,
  loading,
  noLoadingModal,
  heading,
  noTopPadding,
}: Props) => {
  const { translate } = useTranslation();

  if (error)
    return (
      <FailedLoad
        message={!error.status ? translate!('There are connection problems.', '') : null}
      />
    );
  if (loading) return <Loader visible={!noLoadingModal} />;

  return (
    <div className={`datagrid-no-responsive-container${noTopPadding ? ' no-top-padding' : ''}`}>
      {heading && (
        <Toolbar>
          {' '}
          <Item location={'before'} html={heading} />
        </Toolbar>
      )}
      {children}
    </div>
  );
};
